import React from "react"
import { Link, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Link as ReactRouterLink } from "react-router-dom"
import { RequirementCard } from "./requirement-card"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { JourneyTypes } from "../ExpenseJourneyTypes"
import { DbgPaths } from "#/utils/Paths"

// Link to the benefit-guide section for the journey the member selected in
// "What is this expense related to?" (state.expenseRelatedTo.value).
const JOURNEY_BENEFIT_GUIDE_PATHS: Record<string, string> = {
  [JourneyTypes.PRESERVATION]: DbgPaths.PRESERVATION_COVERAGE,
  [JourneyTypes.FERTILITY_CARE]: DbgPaths.FERTILITY_COVERAGE,
  [JourneyTypes.PREGNANCY_AND_POSTPARTUM_SERVICES]: DbgPaths.PREGNANCY_COVERAGE,
  [JourneyTypes.MENOPAUSE]: DbgPaths.MENOPAUSE,
  [JourneyTypes.LOW_TESTOSTERONE]: DbgPaths.LOW_TESTOSTERONE,
  [JourneyTypes.GENDER_AFFIRMING_CARE]: DbgPaths.GENDER_AFFIRMING_CARE
}

export const PelvicFloorRequirementsCard = (): JSX.Element => {
  const { state } = useReimbursementContext()
  // Fall back to the coverage landing if the journey has no dedicated benefit-guide section.
  const benefitGuidePath = JOURNEY_BENEFIT_GUIDE_PATHS[state.expenseRelatedTo?.value] ?? DbgPaths.CARROT_ELIGIBLE

  return (
    <RequirementCard
      title={<FormattedMessage defaultMessage="Pelvic floor physical therapy requirements" />}
      body={[
        <Typography key="pfpt-requirement" variant="body1">
          <FormattedMessage
            defaultMessage="This type of care is only eligible when received through Origin. Learn more in your <link>benefit guide</link>."
            values={{
              link: (linkContent) => (
                <Link component={ReactRouterLink} target="_blank" to={benefitGuidePath} color="inherit">
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      ]}
    />
  )
}
